import React from 'react';

const CancelRoundedIcon = ({fill="#229DEC"}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 32)" fill="url(#paint0_linear_541_1525)"/>
    <circle cx="14" cy="14" r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 2 30)" fill="white"/>
    <path d="M16.0002 9.3335C12.3135 9.3335 9.3335 12.3135 9.3335 16.0002C9.3335 19.6868 12.3135 22.6668 16.0002 22.6668C19.6868 22.6668 22.6668 19.6868 22.6668 16.0002C22.6668 12.3135 19.6868 9.3335 16.0002 9.3335ZM18.8668 18.8668C18.6068 19.1268 18.1868 19.1268 17.9268 18.8668L16.0002 16.9402L14.0735 18.8668C13.8135 19.1268 13.3935 19.1268 13.1335 18.8668C12.8735 18.6068 12.8735 18.1868 13.1335 17.9268L15.0602 16.0002L13.1335 14.0735C12.8735 13.8135 12.8735 13.3935 13.1335 13.1335C13.3935 12.8735 13.8135 12.8735 14.0735 13.1335L16.0002 15.0602L17.9268 13.1335C18.1868 12.8735 18.6068 12.8735 18.8668 13.1335C19.1268 13.3935 19.1268 13.8135 18.8668 14.0735L16.9402 16.0002L18.8668 17.9268C19.1202 18.1802 19.1202 18.6068 18.8668 18.8668Z" fill={fill}/>
    <defs>
    <linearGradient id="paint0_linear_541_1525" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
      <stop stopColor="#2580AC"/>
      <stop offset="0.885417" stopColor="#00AAFF"/>
    </linearGradient>
    </defs>
</svg>
);

export default CancelRoundedIcon;
